<template>
    <ReturnsToInventory></ReturnsToInventory>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const ReturnsToInventory = defineAsyncComponent(() =>
    import("../../components/Logistics/ReturnsToInventory/ReturnsToInventory.vue")
);
export default {
    name: "Logistics_ReturnsToInventory", //The name you are in should not equal the name of the component you are importing.
    components: { ReturnsToInventory, AuthLayout },
};
</script>
